/**
 * «Выбрать отель» после входа: показываем один раз за вход, если у
 * сотрудника два и больше отелей. Флаг — в sessionStorage: переживает
 * перезагрузку вкладки, но не новый вход.
 */
const KEY = 'hk.pickHotel';

export function markPickHotel(on: boolean) {
  try {
    if (on) sessionStorage.setItem(KEY, '1');
    else sessionStorage.removeItem(KEY);
  } catch {
    /* приватный режим — просто без экрана выбора */
  }
}

export function needPickHotel(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
